export default "__VITE_ASSET__BoLcNHAb__"